import React from "react"
import {ButtonLoadingSeeker} from "@ui-seeker/core"
import {useUserSettingsTier, useUserSettingsTierValidator} from "../../@hooks"


export default function UserSettingTierDrawerSubmit() {
	const {isLoading, handleSubmitTierFormData} = useUserSettingsTier()
	const {isValid} = useUserSettingsTierValidator()

	return <ButtonLoadingSeeker
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitTierFormData}
	>
		Save
	</ButtonLoadingSeeker>
}